// Permission tabs (catalog v1). Order = display order in the preview matrix.
export enum EPermissionTab {
  Users = 'users',
  Stores = 'stores',
  Menu = 'menu',
  Promos = 'promos',
  Feedback = 'feedback',
  Statistics = 'statistics',
  QR = 'qr',
  Bitecoins = 'bitecoins',
  Portal = 'portal',
}

// Access levels are ordinal: granted >= required.
export enum EAccessLevel {
  NoAccess = 0,
  ViewOnly = 1,
  Edit = 2,
  Download = 3,
}

export const permissionTabLabel: Record<EPermissionTab, string> = {
  [EPermissionTab.Users]: 'Users',
  [EPermissionTab.Stores]: 'Stores',
  [EPermissionTab.Menu]: 'Menu',
  [EPermissionTab.Promos]: 'Promos',
  [EPermissionTab.Feedback]: 'Feedback',
  [EPermissionTab.Statistics]: 'Statistics',
  [EPermissionTab.QR]: 'QR',
  [EPermissionTab.Bitecoins]: 'Bitecoins',
  [EPermissionTab.Portal]: 'Portal (Revenue)',
};

export const accessLevelLabel: Record<EAccessLevel, string> = {
  [EAccessLevel.NoAccess]: 'No Access',
  [EAccessLevel.ViewOnly]: 'View Only',
  [EAccessLevel.Edit]: 'Edit',
  [EAccessLevel.Download]: 'Download',
};

// tab -> level. A profile omits NoAccess tabs; treat a missing tab as NoAccess.
export type IPermissionMatrix = Components.Schemas.ProfileDto['matrix'];

export interface IProfile extends Components.Schemas.ProfileDto {}

export interface IProfileCollection extends Components.Schemas.ProfileCollectionDto {}

// Store scope assigned to a franchisor user.
export enum EStoreScopeType {
  All = 'all',
  Region = 'region',
  Group = 'group',
  Stores = 'stores',
}

export const storeScopeTypeLabel: Record<EStoreScopeType, string> = {
  [EStoreScopeType.All]: 'All stores',
  [EStoreScopeType.Region]: 'Region',
  [EStoreScopeType.Group]: 'Group',
  [EStoreScopeType.Stores]: 'Specific stores',
};

export interface IStoreScope {
  type: EStoreScopeType | null;
  ids: string[];
}
